module.exports = __webpack_public_path__ + "website/img/enterprise.988fca21.png";